export default __webpack_public_path__ + "static/media/uploader-insuletOmnipod-2.f789fc24.png";